export default function ResourceFactory() {
    var fn = this;

    /**
     * API V3
     */

    fn.lookupResource = (id, resources) => {
        return resources.find((resource) => resource.id === id);
    };

    fn.lookupLaneDependencies = (id, dependencies) => {
        if (!dependencies) {
            return [];
        }
        // example dependecy : {resourceId: 21, resourceId2: 11}
        return dependencies
            .filter((dependency) => {
                // return onlyt if we have a match in the pair
                return (
                    dependency.resourceId === id ||
                    dependency.resourceId2 === id
                );
            })
            .map((dependency) => {
                // then only return the opposite value (other lane dep)
                return dependency.resourceId === id // if
                    ? dependency.resourceId2
                    : dependency.resourceId2 === id // else if
                    ? dependency.resourceId
                    : false;
            });
    };

    return fn;
}
